import React, { forwardRef, useState } from 'react';

import styles from './Image.module.scss';
import type { ImageProps } from './Image';

/**
 * VD Private component
 */
const ImageBasic = forwardRef<HTMLImageElement, ImageProps>(({ className, image, alt = '' }, ref) => {
  const [loaded, setLoaded] = useState(false);

  return (
    <img
      style={{ opacity: loaded ? 1 : 0, transition: 'opacity 0.2s ease-out' }}
      ref={ref}
      className={`${className} ${styles.image}`}
      src={image}
      alt={alt}
      onLoad={() => setLoaded(true)}
    />
  );
});

export default React.memo(ImageBasic);
